
define('text!templates/content/wallet_histories.html',[],function () { return '<div class="panel panel-transparent">\n    <div class="panel-body">\n        <div class="clearfix"></div>\n       \n        <div class="main-list-container">\n            \n        </div>\n    </div>\n</div>';});

